import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { SearchRequest } from '../common/SearchRequest';
import { Artist } from './Artist';
import { Pro } from './Pro';


export class CompanySearchRequest extends SearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public artistIds: string[] = [];
	public proIds: string[] = [];
	public artists: Artist[] = [];
	public pros: Pro[] = [];
	public startYear?: number;
	public endYear?: number;
	public isEnabled?: boolean = null;
	public isPopular?: boolean = null;

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.artistIds) {
			this.artistIds = Array.isArray(init.artistIds)
				? init.artistIds
				: init.artistIds.split(',');
		}
		if (init.proIds) {
			this.proIds = Array.isArray(init.proIds)
				? init.proIds
				: init.proIds.split(',');
		}
		if (init.startYear) { this.startYear = parseInt(init.startYear, null); }
		if (init.endYear) { this.endYear = parseInt(init.endYear, null); }
		if (init.isEnabled != null) { this.isEnabled = (init.isEnabled.toString() === 'true'); }
		if (init.isPopular != null) { this.isPopular = (init.isPopular.toString() === 'true'); }

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('company-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as CompanySearchRequest;
		if (!prevFilter) { return; }

		if (prevFilter?.artists?.length) {
			for (const id of this.artistIds) {
				const found = prevFilter.artists.find((x) => x.id === id);
				if (found) { this.artists.push(found); }
			}
		}

		if (prevFilter?.pros?.length) {
			for (const id of this.proIds) {
				const found = prevFilter.pros.find((x) => x.id === id);
				if (found) { this.pros.push(found); }
			}
		}

	}

	public collapse(): any {
		const response: { [k: string]: any } = super.collapse();
		if (this.artistIds && this.artistIds.length) { response.artistIds = this.artistIds.join(','); }
		if (this.proIds && this.proIds.length) { response.proIds = this.proIds.join(','); }
		if (this.startYear) { response.startYear = this.startYear; }
		if (this.endYear) { response.endYear = this.endYear; }
		if (this.isEnabled != null) { response.isEnabled = this.isEnabled; }
		if (this.isPopular != null) { response.isPopular = this.isPopular; }
		return response;
	}

	public clear() {
		super.clear();
		this.artistIds = [];
		this.proIds = [];
		this.isEnabled = null;
		this.isPopular = null;
	}

}
